<template>
    <div  v-if="wizard && showWizard">
      <div class="f20-l30-b pointer" @click="$emit('close')">X</div> 
      <WizardPopupComponent
        ref="wizardPopup" 
        :showClose="showClose" 
        :wizard="wizard" 
        @close="$emit('close')" 
        :formMethod="formMethod" 
        @submit="handleSubmit"
        class="wizard-ai-width"
      />
    </div>

    <!-- Processing indicator -->
    <div v-if="showLoadingIndicator" class="loader-container margin-top-20">
      <LoadingIndicator dir="ltr" />
      <div class="processing-message text-center margin-top-10 f14-l19 bold"
        v-if="this.wizard?.processing_message"
        v-html="this.wizard.processing_message">
      </div>
    </div>

    <!-- Response message -->
    <div v-if="responseMessage" class="margin-top-20">
      <div class="f16-l17 text-center" v-if="responseMessage.title" v-html="responseMessage.title"></div>
      <div class="f14-l17 text-center margin-top-10" v-html="responseMessage.text"></div>
    </div>
    <!-- Response buttons -->
    <div v-if="responseButtons && responseButtons.length > 0" class="margin-top-20">
      <HorizontalSplitter class="margin-tb-20" />
      <div class="d-flex flex-row">
        <ButtonComponent 
          v-for="(btn, index) in responseButtons" 
          :key="index" 
          :caption="btn.label" 
          @click="btnAction(btn)" 
          @keyup.enter="btnAction(btn)" 
          class="flex-grow-1 margin-lr-5" 
        />
      </div>
    </div>
</template>
<script>
import {formSubmit, fetch2} from '@/modules/configuration.js';
import {openCart} from '@/modules/utils.js';
import ButtonComponent from "@/components/form/ButtonComponent"
import HorizontalSplitter from "@/components/generic/HorizontalSplitter.vue"
import LoadingIndicator from '@/components/LoadingIndicator.vue'
import WizardPopupComponent from "@/components/search/WizardPopupComponent";
import { logger } from '@/utils/logger';

export default {
  emits: ['close', 'wizard-loaded', 'submit'],
  components: {
    ButtonComponent,
    HorizontalSplitter,
    LoadingIndicator,
    WizardPopupComponent
  },
  props: {
    content: Object,
    url: Object,
    formMethod: {
      type: String,
      default: 'GET'
    },
    useWebSocket: {
      type: Boolean,
      default: false
    },
    showClose: Boolean,
    userSessionId: String,
    onSubmitHandler: Function
  },
  data() {
    return {
      popupLoadingIndicator: false,
      loading: false,
      wizard: null,
      isSubmitting: false,
      responseMessage: null,
      responseButtons: [],
      showWizard: true,
      showLoadingIndicator: false,
    }
  },
  mounted() {
    const u = this.url?.url;
    if (u && u.indexOf('wizard') >= 0) {
      this.getData(this.url.url).catch(error => {
        logger.error('Error in mounted:', error);
      });
    }
  },
  methods: {
    async getData(url) {
      try {
        this.loading = true;
        const data = await fetch2(this, url);
        if (Object.keys(data).length === 0) return null;
        this.wizard = data;
        this.loading = false;
        
        if (data.user_session_id) {
          this.$emit('wizard-loaded', data.user_session_id);
        }
        
        return data;
      } catch (error) {
        logger.error('Error in mounted:', error);
        this.loading = false;
        return null;
      }
    },

    async handleSubmit(formData) {
      logger.log('AIWizardPopupComponent: handleSubmit called');
      this.isSubmitting = true;
      this.errorMessage = null;
      this.responseMessage = null;
      this.responseButtons = [];
      
      try {
        // Ensure we have a proper form element
        if (!(formData instanceof HTMLFormElement) && !(formData instanceof FormData)) {
          throw new Error('Invalid form input');
        }
        
        const actualFormData = formData instanceof FormData ? formData : new FormData(formData);
        const formDataObj = { conversation: {} };
        const fieldValues = {};
        
        actualFormData.forEach((value, key) => {
          if (!fieldValues[key]) fieldValues[key] = [];
          fieldValues[key].push(value);
        });
        
        Object.entries(fieldValues).forEach(([key, values]) => {
          const matches = key.match(/^conversation\[([^\]]+)\](\[\])?$/);
          if (matches) {
            const [, fieldName, isArray] = matches;
            if (isArray) {
              formDataObj.conversation[fieldName] = values;
            } else {
              formDataObj.conversation[fieldName] = values[values.length - 1];
            }
          }
        });
        this.$refs.wizardPopup?.wizardSkip(1);
        logger.log('AIWizardPopupComponent: About to call onSubmitHandler');
        if (this.onSubmitHandler) {
          this.onSubmitHandler(formDataObj);
        }
      } catch (error) {
        logger.error('AIWizardPopupComponent: Error in handleSubmit', error);
        this.handleError(error);
      } finally {
        this.isSubmitting = false;
      }
    },

    async btnAction(btn) {
      if (!btn) return;
      try {
        if (btn.cancel) {
          this.$emit('close');
          return;
        }

        if (btn.method === 'POST') {
          let postData = {};
          if (btn.post_params) {
            btn.post_params.forEach(param => {
              postData[param.name] = param.val;
            });
          }

          const response = await formSubmit(this, null, btn.href, postData);
          this.$emit('orderUpdated', response);
        } 
        else {
          let link = btn.url || btn.href;
          if (link) {
            if (link.indexOf("add_to_cart") > 0) {
              let response = await formSubmit(this, null, link);
              if (response.popup_content || response?.prompt_json?.popup_content) {
                openCart(this,response);
              }
            } else {
              if (this.$route.fullPath == link) {
                this.$router.go(0);
              } else if (link.indexOf("/") == 0) {
                const path = link.split('?')[0];
                if (this.$route.path == path){
                  window.location.href = link;
                } else {
                  this.$router.push(link);
                }
              }
            }
          }
        }
        this.$emit('close');
     } catch (error) {
        this.handleError(error);
      }
    },

    contentIsString() {
      return this?.content instanceof String;
    },

    openpopup(json) {
      this.$emit('close');
      this.$store.dispatch('showPopup', {form: json, requestId: this.content?.requestId});
    },

    customizeField(field) {
      field["desktopClass"] = "col-12";
      return field;
    },

    classSelector() {
      return this.content.form.style + '_iframe';
    },

    async submitViaHttp(form) {
      try {
        this.isSubmitting = true; // Set isSubmitting to true
        const response = await formSubmit(this, form, null, null);
        // eslint-disable-next-line
        if (response.hasOwnProperty("success") && response.success === false && response.error) {
          this.errorMessage = response.error;
          this.isSubmitting = false; // Reset isSubmitting to false
          return;
        }
        // eslint-disable-next-line
        else if (response.hasOwnProperty("success") && response.success === true && response.message) {
          this.responseMessage = response.message;
          if (response.content && response.content.buttons) {
            this.responseButtons = response.content.buttons; // Set responseButtons based on response content
          }
          this.isSubmitting = false; // Reset isSubmitting to false
          if (response.keep_open) {
            return;
          }
        }
        this.$emit('close', response.success, response, this.content?.requestId);
        this.isSubmitting = false; // Reset isSubmitting to false
      } catch (error) {
        this.handleError(error);
      }
    },

    handleError(error) {
      this.errorMessage = typeof error === 'string' ? error : error.message;
      this.showLoadingIndicator = false;
      this.isSubmitting = false;
    },
  },
  watch: {
    async $route(to/*, from*/) {
      if (to.hash === "#loading") {
        this.popupLoadingIndicator = true;
      }
      if (to.hash === "#loaded") {
        this.popupLoadingIndicator = false;
      }
    }
  }
}
</script>
<style>
.wizard-ai-width {
  width: 80%;
  margin-right: auto;
  margin-left: auto;
}
/* You can scope this to your popup if needed */
.wizard-ai-list {
  list-style: none;
  padding: 0;
  margin: 0 auto;
  direction: rtl;
  width: fit-content;
}

.wizard-ai-list li {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  text-align: right;
  gap: 0.4em;
  margin-bottom: 0.5em;
  font-size: 1em;
  direction: rtl;
}
.wizard-ai-list li::before {
  content: "•";
  color: #222;
  font-size: 1.2em;
  line-height: 1;
  display: inline-block;
  width: 1em;
  text-align: right;
}
</style>
<style scoped>
.processing-message {
  text-align: center;
  margin-top: 1rem;
  color: #666;
}

.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}
.formfield-no-margin .formfield-margin-wrapper {
  margin: 0;
}

.card_iframe {
  width: 300px; 
  height: 450px; 
  margin: auto;
}
.credit_iframe {
  width: 300px; 
  height: 450px; 
  margin: auto;
}

.bit_iframe {
  z-index: 100;
  width: 100%;
  height: 100%;
  position: fixed;
  border: 0;
  top: 0;
  right: 0;
  background-color: transparent !important;
}
.apple_iframe {
  width: 300px; 
  height: 300px; 
  margin: auto;
}

.google_iframe {
  width: 300px; 
  height: 300px; 
  margin: auto;
}

.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px; /* Adjust height as needed */
  min-height: 300px;
}

.button-group {
  display: flex;
  flex-direction: column;
  align-items: center;
}

</style>